import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MediaImg from "./MediaImg";
import Reveal from "./Reveal";

export default function ArticleCard({ article, index = 0 }) {
  return (
    <Reveal delay={index * 0.08} className="h-full">
      <Link
        to={`/tulisan/${article.slug}`}
        data-testid={`article-card-${article.slug}`}
        className="group flex flex-col h-full bg-surface border border-line rounded-lg overflow-hidden hover:shadow-[0_12px_32px_rgba(32,37,34,0.08)] transition-shadow"
      >
        <MediaImg id={article.cover_id} alt={article.cover_alt || article.title} ratio="3/2">
          <span className="font-serif italic text-faint text-sm">Tanpa cover</span>
        </MediaImg>
        <div className="flex flex-col flex-1 p-6">
          <div className="flex items-center gap-3 text-[12px] uppercase tracking-[0.14em] font-semibold">
            <span className="text-enji">{article.category || "Tulisan"}</span>
            <span className="w-1 h-1 rounded-full bg-faint" aria-hidden="true" />
            <span className="text-faint normal-case tracking-normal font-medium">{article.reading_minutes} menit baca</span>
          </div>
          <h3 className="font-serif text-xl leading-snug mt-3 text-ink">{article.title}</h3>
          <p className="text-sub text-[15px] leading-relaxed mt-2 line-clamp-3 flex-1">{article.excerpt}</p>
          <span className="inline-flex items-center gap-2 text-enji font-semibold text-sm mt-5">
            Baca tulisan
            <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
}

